import React from 'react';
import InlineEditableElement from 'Components/InlineEditableElement';
import {hoc} from 'Page/Sections/Heading/Heading';

class Heading extends React.Component {
  render() {
    let section = this.props.section;
    return (
      <div className="text-center">
        <InlineEditableElement
          el="h2"
          {...this.props.inlineEditorProps}
          fontFamilyChanged={this.props.fontFamilyChanged}
          className="section-heading"
          html={section.prop('title')}
          onChange={this.props.titleChanged.bind(this)}
          inlineEditingEnabled={this.props.inlineEditingEnabled}
        />
        {typeof section.prop('subtitle') !== 'undefined' ||
        this.props.inlineEditingEnabled ? (
          <InlineEditableElement
            fontFamilyChanged={this.props.fontFamilyChanged}
            html={section.prop('subtitle')}
            {...this.props.inlineEditorProps}
            className="section-heading"
            onChange={this.props.subtitleChanged.bind(this)}
            inlineEditingEnabled={this.props.inlineEditingEnabled}
          />
        ) : null}
        <hr />
      </div>
    );
  }
}

export default hoc(Heading);
